/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum DateTimeFormat {
  MILITARY="MILITARY",
TWELVE_HOUR="TWELVE_HOUR"
}

/**
* DateTimeFormat
*/
export const DateTimeFormatEnumType = types.enumeration("DateTimeFormat", [
        "MILITARY",
  "TWELVE_HOUR",
      ])
